import {UserComponentManager} from './UserComponentManager';

const Component_BlendShape = UserComponentManager.createComponent('blendShape');
Component_BlendShape.MasterSettings = {
  clock: 0,
  counter: 0,
  rate: 0.2,
  offset: Math.PI,
  offsetScale: 1,
  overrideActive: false,
};

Component_BlendShape.clockTick = function(dt) {
  const m = Component_BlendShape.MasterSettings;
  if (!m.overrideActive) {
    m.counter += (dt * m.rate);
    m.counter = m.counter % (Math.PI * 4);
    m.clock = 0.5 + (Math.sin(m.counter + m.offset) * 0.5);
  }
};

Component_BlendShape.getParams = function() {
  return {
    blends: [],
  };
};

Component_BlendShape.attachToEntity = function(entity) {
  const p = Component_BlendShape.getParams();
  p.entity = entity;
  this.active[entity.name] = p;
  return p;
};

Component_BlendShape.do = function(obj, dt) {
  const m = Component_BlendShape.MasterSettings;
  obj.blends.forEach((blend) => {
    blend.morphInstance.setWeight(0, m.clock);
    blend.morphInstance.update();
  });
};


export {Component_BlendShape};
